import { Injectable, OnDestroy, HostListener } from '@angular/core';
import { EScreenMedia } from '../../core/enumerables/screenMedia';
import { ESidebarState } from '../enumerables/sidebarState';
import { ESidebarPosition } from '../enumerables/sidebarPosition';
import { BehaviorSubject, Subscription, Subject } from 'rxjs';
import { ParameterHandlerService } from 'projects/common/src/app/services';

@Injectable({
  providedIn: 'root'
})
export class StateSidebarService implements OnDestroy {

  public stateSource: BehaviorSubject<ESidebarState>;
  public positionSource: BehaviorSubject<ESidebarPosition>;
  public toggleSource: BehaviorSubject<boolean>;
  public sizeChanged: Subject<any>;

  private isToggled: boolean;
  private state: ESidebarState;
  private position: ESidebarPosition;
  private screenMediaSubscription: Subscription;

  constructor(
    private parameterService: ParameterHandlerService
  ) {
    this.state = ESidebarState.open;
    this.position = ESidebarPosition.fixed;
    this.isToggled = false;
    this.stateSource = new BehaviorSubject(this.state);
    this.toggleSource = new BehaviorSubject(false);
    this.positionSource = new BehaviorSubject(this.position);
    this.sizeChanged = new Subject();
    this.screenMediaSubscription = this.parameterService.parameterSource.item('screen-media').subscribe((screen: EScreenMedia) => {
      switch (screen) {
        case EScreenMedia.xs:
          this.setPosition(ESidebarPosition.float);
          this.setState(ESidebarState.closed);
          break;
        case EScreenMedia.sm:
          this.setPosition(ESidebarPosition.float);
          this.setState(ESidebarState.closed);
          break;
        case EScreenMedia.md:
          this.setPosition(ESidebarPosition.float);
          this.setState(ESidebarState.closed);
          break;
        case EScreenMedia.lg:
          this.setPosition(ESidebarPosition.fixed);
          this.setState(ESidebarState.open);
          break;
        case EScreenMedia.xl:
          this.setPosition(ESidebarPosition.fixed);
          this.setState(ESidebarState.open);
          break;
        default:
          break;
      }
    });
  }

  public ngOnDestroy(): void {
    this.screenMediaSubscription.unsubscribe();
  }

  public setState(state: ESidebarState): void {
    this.state = state;
    this.stateSource.next(this.state);
  }

  public getState(): ESidebarState {
    return this.state;
  }

  public toggleState(): void {
    this.state = this.state === ESidebarState.open ? ESidebarState.closed : ESidebarState.open;
    this.stateSource.next(this.state);
  }

  public toggleSidebar(): void {
    this.isToggled = !this.isToggled; 
    this.toggleSource.next(this.isToggled);
  }

  public setPosition(position: ESidebarPosition): void {
    this.position = position;
    this.positionSource.next(this.position);
  }

  public getPosition(): ESidebarPosition {
    return this.position;
  }

  public setSize(event: any): void {
    this.sizeChanged.next(event);
  }
}
